import { Splide } from "@splidejs/splide";


const init = () => {
  const mainEl = document.getElementById('js-reservationMain');
  const bubbleEl = document.getElementById('js-reservationBubble');
  if (!mainEl || !bubbleEl) return;

  const bubble = new Splide(bubbleEl, {
    type: 'fade',
    rewind: true,
    arrows: false,
    pagination: false,
    drag: false,
    speed: 600,
  }).mount();

  const main = new Splide(mainEl, {
    type: 'slide',
    fixedWidth: "23.8rem",
    gap: "4.5rem",
    focus: 'center',
    trimSpace: false,
    arrows: false,
    pagination: false,
    drag: true,
    speed: 500,
    perMove: 1,
    flickMaxPages: 1,
    flickPower: 100,
    dragMinThreshold: { mouse: 12, touch: 12 },
    easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
    waitForTransition: false,
  }).mount();

  main.sync( bubble );
};

export default init;
